export default __webpack_public_path__ + "static/jaredd-craig-HH4WBGNyltc-unsplash-fc8bd904347c84991bb386092c3c417a.jpg";